// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductPageProvider__AdomikLoader___zFOR9{background:none}`, "",{"version":3,"sources":["webpack://./src/components/data/providers/ProductPageProvider/ProductPageProvider.scss"],"names":[],"mappings":"AAAA,2CACE,eAAA","sourcesContent":[".AdomikLoader {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export var AdomikLoader = `ProductPageProvider__AdomikLoader___zFOR9`;
export default ___CSS_LOADER_EXPORT___;
